module.exports = __webpack_public_path__ + "static/don34-0c11d0b39065db11834021156421c965.jpg";